export const StepperInActive = () => (
  <svg width="38" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="26" height="26" rx="13" stroke="white" strokeWidth="2" />
  </svg>
);
